import React, { useMemo } from 'react';
import { Edit3, Shield } from './Icons/index.js';
import { PALETTE } from './SearchableDropdown.js';
import SearchableSelect from './SearchableSelect.js';
const ICON = {
    system: { icon: React.createElement(Shield, null), palette: PALETTE.neutral },
    tenant: { icon: React.createElement(Edit3, null), palette: PALETTE.accent },
};
const originOf = (item) => item.public ? 'system' : 'tenant';
const originIcon = (item) => ICON[originOf(item)];
const itemName = (item) => item.name;
const notArchived = (item) => !item.archived;
/**
 * Searchable select for billing models and billing appendix setups:
 * archived items are left out and a chip tells system from tenant-created
 */
export const SystemOrTenantSelect = (props) => {
    const { filter, labels } = props;
    const selectable = useMemo(() => filter ? (item) => notArchived(item) && filter(item) : notArchived, [filter]);
    const facet = useMemo(() => ({
        of: originOf,
        options: [
            { key: 'system', label: labels.system, icon: ICON.system.icon },
            { key: 'tenant', label: labels.tenant, icon: ICON.tenant.icon },
        ],
    }), [labels.system, labels.tenant]);
    return (React.createElement(SearchableSelect, { ...props, placeholder: props.placeholder ?? labels.placeholder, filter: selectable, getLabel: itemName, getIcon: originIcon, getDescription: (item) => labels[originOf(item)], facet: facet, labels: { search: labels.search, all: labels.all } }));
};
//# sourceMappingURL=SystemOrTenant.js.map